import image from '../../src/assets/images/user.png'
import photo from '../../src/assets/images/hotel12.jpg'

const options = {  maximumFractionDigits: 2 }

export const userColumns = [
    
    { field: 'customerID', title: 'CustomerID', width: 60 },
    { field: 'userImage', title: 'Photo', width:40, render: rowData => <img src={rowData.userImage ? rowData.userImage : image} style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'firstname', title: 'Firstname', width: 80 },
    { field: 'lastname', title: 'Lastname', width: 80 },
    { field: 'email', title: 'Email', width: 670 },
    { field: 'phoneNumber', title: 'Telephone', width: 100 },
    { field: 'referalCode', title: 'Referal Code', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
    // { field: 'date', title: 'Date', width: 80, render: rowData =>  
        
    //     {

    //         if (rowData.timeStamp) {
    //             const date = rowData.timeStamp.toDate();
    //             return date.toLocaleDateString();
    //         }
    //         return '';

    //     }
        
    //  },
    { field: 'status', title: 'Status', width: 60, render: rowData => <div className={`cellstatus ${rowData.status}`}>{rowData.status === "active"? "active": "inactive"} </div>
      
    },
   
]



export const subscriberColumns = [ 
    
    { field: 'customerID', title: 'Subscriber ID', width: 60 },
    { field: 'userImage', title: 'photo', width:60, render: rowData => <img src={rowData.userImage ? rowData.userImage : image} style={{width: 50, height:50, borderRadius: '50%'}}/>},
    { field: 'firstname', title: 'Firstname', width: 80 },
    { field: 'lastname', title: 'Lastname', width: 80 },
    { field: 'email', title: 'Email', width: 60 },
    { field: 'timeStamp', title: 'Date', width: 80, render: rowData =>  
        
        {

            if (rowData.timeStamp) {
                const date = rowData.timeStamp.toDate();
                return date.toLocaleDateString();
            }
            return '';

        }
        
     },
    { field: 'phoneNumber', title: 'Telephone', width: 80 },
    { field: 'status', title: 'status', width: 80, render: rowData => <div className={`cellstatus ${rowData.status}`}>{rowData.status} </div>
        
    },
   

]


export const outletsColumns = [
    
    { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
    { field: 'photo', title: 'photo', width:60, render: rowData => <img src={rowData.files[0] ? rowData.files[0] : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'outletname', title: 'Outlet', width: 100 },
    { field: 'outlet', title: 'Outlet', width: 100 },
    { field: 'region', title: 'Region', width: 100 },
    { field: 'area', title: 'Area', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
    { field: 'subscriberPlan', title: 'Plan', width: 100 },
    { field: 'amount', title: 'Amount', width: 100, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
      
    },
    
    { field: 'date', title: 'Payment Date', width: 80 },
    { field: 'expiration', title: 'Expiration Date', width: 80 },
    { field: 'agentCode', title: 'Agent Code', width: 60 },
    { field: 'outlet', title: 'Outlet', width: 60 },
    { field: 'outletname', title: 'Outlet Name', width: 160 },
    { field: 'paymentreference', title: 'Payment Reference', width: 100 },
    { field: 'paymentno', title: 'Payment No.', width: 60 },
    
    // { field: 'address', title: 'Address', width: 200 },
    { field: 'userFirstname', title: 'Firstname', width: 60 },
    { field: 'userLastname', title: 'Lastname', width: 60 },
    // { field: 'gender', title: 'Gender', width: 60 },
    { field: 'telephone', title: 'Telephone', width: 60 },
    { field: 'whatsapp', title: 'whatsApp', width: 60 },
   

]

export const paidColumns = [
    
    { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
    { field: 'photo', title: 'photo', width:60, render: rowData => <img src={rowData.files[0] ? rowData.files[0] : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'outletname', title: 'Outlet', width: 100 },
    { field: 'outlet', title: 'Outlet', width: 100 },
    { field: 'region', title: 'Region', width: 100 },
    { field: 'area', title: 'Area', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
    { field: 'subscriberPlan', title: 'Plan', width: 100 },
    { field: 'amount', title: 'Amount', width: 100, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
      
    },
    
    { field: 'date', title: 'Payment Date', width: 80 },
    { field: 'expiration', title: 'Expiration Date', width: 80 },
    { field: 'agentCode', title: 'Agent Code', width: 60 },
    { field: 'outlet', title: 'Outlet', width: 60 },
    { field: 'outletname', title: 'Outlet Name', width: 160 },
    { field: 'paymentreference', title: 'Payment Reference', width: 100 },
    { field: 'paymentno', title: 'Payment No.', width: 60 },
    
    { field: 'status', title: 'Status', width: 60 },
    { field: 'userFirstname', title: 'Firstname', width: 60 },
    { field: 'userLastname', title: 'Lastname', width: 60 },
    // { field: 'gender', title: 'Gender', width: 60 },
    { field: 'telephone', title: 'Telephone', width: 60 },
    { field: 'whatsapp', title: 'whatsApp', width: 60 },
   

] 

export const outletEventColumns = [
    
    // { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
    { field: 'outletImage', title: 'photo', width:60, render: rowData => <img src={rowData.outletImage ? rowData.outletImage : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'category', title: 'Category', width: 100 },
    { field: 'eventDate', title: 'Event Date', width: 100 },
    { field: 'eventTime', title: 'Event Time', width: 100 },
    // { field: 'sideAttraction', title: 'Side Attraction', width: 100 },
    { field: 'status', title: 'Status', width: 100 },
  

]



export const unpaidColumns = [
    
    { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
    { field: 'photo', title: 'photo', width:60, render: rowData => <img src={rowData.files[0] ? rowData.files[0] : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'outletname', title: 'Outlet', width: 100 },
    { field: 'outlet', title: 'Outlet', width: 100 },
    { field: 'region', title: 'Region', width: 100 },
    { field: 'area', title: 'Area', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
    { field: 'subscriberPlan', title: 'Plan', width: 100 },
    { field: 'amount', title: 'Amount', width: 100, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
      
    },
    
    { field: 'date', title: 'Payment Date', width: 80 },
    { field: 'expiration', title: 'Expiration Date', width: 80 },
    { field: 'agentCode', title: 'Agent Code', width: 60 },
    { field: 'outlet', title: 'Outlet', width: 60 },
    { field: 'outletname', title: 'Outlet Name', width: 160 },
    { field: 'paymentreference', title: 'Payment Reference', width: 100 },
    { field: 'paymentno', title: 'Payment No.', width: 60 },
    { field: 'status', title: 'Status', width: 60 },
    { field: 'userFirstname', title: 'Firstname', width: 60 },
    { field: 'userLastname', title: 'Lastname', width: 60 },
    // { field: 'gender', title: 'Gender', width: 60 },
    { field: 'telephone', title: 'Telephone', width: 60 },
    { field: 'whatsapp', title: 'whatsApp', width: 60 },
   

]


export const paymentsColumns = [

    { field: 'transactionStatus', title: 'Transaction Status', width: 120, render: rowData => <div >{rowData.transactionStatus? "Successfull": ' Declined'}</div>},
    { field: 'amount', title: 'Amount', width: 50, render: rowData => <div >N{Intl.NumberFormat("en-US",options).format(rowData.amount)} </div>
    },
    { field: 'plan', title: 'Plan', width: 60 },
    { field: 'date', title: 'Payment Date', width: 160 },
    { field: 'expiration', title: 'Expiration Date', width: 160 },
    { field: 'agentCode', title: 'Agent Code', width: 60 },
    { field: 'outlet', title: 'Outlet', width: 120 },
    { field: 'outletname', title: 'Outlet Name', width: 160 },
    { field: 'paymentReference', title: 'Payment Reference', width: 100 },
    { field: 'paymentno', title: 'Payment No.', width: 60 },
    { field: 'userFirstname', title: 'Firstname', width: 100 },
    { field: 'userLastname', title: 'Lastname', width: 100 },
    { field: 'gender', title: 'Gender', width: 60 },
    { field: 'telephone', title: 'Telephone', width: 60 },
    { field: 'whatsapp', title: 'whatsApp', width: 60 },
    { field: 'address', title: 'Address', width: 120 },

]


export const messageColumns = [
    { field: 'icon', title: 'Icon', width: 80, render: rowData => <div > </div>},
    { field: 'title', title: 'Title', width: 100 },
    { field: 'message', title: 'Message', width: 100 },
    { field: 'plan', title: 'Plan', width: 100 },
    { field: 'status', title: 'Status', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
      
]


export const individualColumns = [
    { field: 'title', title: 'Title', width: 100 },
    { field: 'message', title: 'Message', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
      
]

export const groupColumns = [
    { field: 'title', title: 'Title', width: 100 },
    { field: 'body', title: 'Message', width: 100 },
    { field: 'timestamp', title: 'Date', width: 100 },
      
]


export const advertColumns = [
    
    // { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
    { field: 'advertImage', title: 'Photo', width:60, render: rowData => <img src={rowData.advertImage ? rowData.advertImage : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'title', title: 'Title', width: 100 },
    { field: 'description', title: 'Description', width: 200 },
    { field: 'brandname', title: 'Brand name', width: 100 },
    { field: 'brandaddress', title: 'Brand Address', width: 200 },
    { field: 'brandtelephone', title: 'Brand Telephone', width: 100 },
    { field: 'datePublished', title: 'Date Published', width: 100 },
    { field: 'brandsocials', title: 'Socials', width: 100 },
    { field: 'likeCount', title: 'Likes', width: 30 },
    { field: 'viewCount', title: 'Views', width: 30 },
    { field: 'messageCount', title: 'Messages', width: 30 },
    { field: 'status', title: 'Status', width: 50, render: rowData => <p style={{color: rowData.status === "active" ? "#3a9833ff" : "#ed2020ff"}}>{rowData.status}</p>},

]



export const rewardColumns = [
    
    // { field: 'subscriberID', title: 'OUTLET ID', width: 80 },
    { field: 'imgactive', title: 'Active Photo', width:60, render: rowData => <img src={rowData.imgactive ? rowData.imgactive : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'imginactive', title: 'Inactive Photo', width:60, render: rowData => <img src={rowData.imginactive ? rowData.imginactive : photo} alt="avatar" style={{width: 50, height:50, borderRadius: '50%'}}/>
     
    },
    { field: 'title', title: 'Title', width: 100 },
    { field: 'description', title: 'Description', width: 200 },
    { field: 'coin', title: 'Coin', width: 100 },
    { field: 'price', title: 'Cost Price', width: 200 },
    { field: 'imgtype', title: 'Image Type', width: 200 },
    { field: 'width', title: 'Image Width', width: 100 },
    { field: 'height', title: 'Image Height', width: 100 },
    { field: 'redeemStatus', title: 'Redeem Status', width: 30 },
    { field: 'externalStatus', title: 'External Status', width: 30 },
    { field: 'createdAt', title: 'Created At', width: 80 },
    { field: 'status', title: 'Status', width: 50, render: rowData => <p style={{color: rowData.status === "active" ? "#3a9833ff" : "#ed2020ff"}}>{rowData.status}</p>},

]


export const pointColumns = [
    
    { field: 'like', title: 'Like', width: 100 },
    { field: 'invitefriend', title: 'Invite Friend', width: 200 },
    { field: 'inviteOutlet', title: 'Invite Outlet', width: 200 },
    { field: 'createdAt', title: 'Created At', width: 80 },
    { field: 'status', title: 'Status', width: 50, render: rowData => <p style={{color: rowData.status === "active" ? "#3a9833ff" : "#ed2020ff"}}>{rowData.status}</p>},

]



export const rewardLocationColumns = [
    
    { field: 'name', title: 'Name', width: 100 },
    { field: 'address', title: 'Address', width: 200 },
    { field: 'telephone', title: 'Telephone', width: 200 },
    { field: 'email', title: 'Email', width: 200 },
    { field: 'createdAt', title: 'Created At', width: 80 },
    { field: 'status', title: 'Status', width: 50, render: rowData => <p style={{color: rowData.status === "active" ? "#3a9833ff" : "#ed2020ff"}}>{rowData.status}</p>},

]


export const contactColumns = [
    
    { field: 'fullname', title: 'Name', width: 100 },
    { field: 'email', title: 'Address', width: 200 },
    { field: 'subject', title: 'Telephone', width: 200 },
    { field: 'message', title: 'Email', width: 200 },
    { field: 'telephone', title: 'Phone Number', width: 200 },
    { field: 'date', title: 'Date', width: 80 },
    { field: 'status', title: 'Status', width: 50, render: rowData => <p style={{color: rowData.status === "READ" ? "#3a9833ff" : "#ed2020ff"}}>{rowData.status}</p>},

]


export const releasesColumns = [
    // { field: 'icon', title: 'Icon', width: 80, render: rowData => <div > </div>},
    { field: 'title', title: 'Title', width: 100 },
    { field: 'message', title: 'Message', width: 100 },
    // { field: 'plan', title: 'Plan', width: 100 },
    { field: 'date', title: 'Date', width: 100 },
    { field: 'status', title: 'Status', width: 100 },
      
]




export const staffColumns = [
    { field: 'staffID', headerName: 'Staff ID', width: 80 },
    { 
        field: 'photo', headerName: 'Photo', width:80,
        renderCell:(params) => {
            return(
                <div className="cellwithphoto">
                    <img src={params.row.img} alt="avatar" className="cellphoto"/>
                    
                </div>
            )
        }
    },
    { field: 'firstname', headerName: 'Firstname', width: 150 },
    { field: 'lastname', headerName: 'Lastname', width: 150 },
    { field: 'role', headerName: 'Staff Role', width: 180 },
    { field: 'telephone', headerName: 'Phone Number', width: 150 },
    { field: 'date', headerName: 'Reg Date', width: 100 },
    { field: 'email', headerName: 'Email Address', width: 160 },

    { field: 'status', headerName: 'Status', width: 80,
        renderCell:(params) => {
            return <div className={`cellstatus ${params.row.status}`}>{params.row.status} </div>
        },
    },
]

export const agentColumns = [
    { field: 'agentID', headerName: 'Agent Code', width: 130 },
    { 
        field: 'photo', headerName: 'Photo', width:100,
        renderCell:(params) => {
            return(
                <div className="cellwithphoto">
                    <img src={params.row.img} alt="avatar" className="cellphoto"/>
                    
                </div>
            )
        }
    },
    { field: 'firstname', headerName: 'Firstname', width: 150 },
    { field: 'lastname', headerName: 'Lastname', width: 150 },
    { field: 'role', headerName: 'Agent Role', width: 180 },
    { field: 'telephone', headerName: 'Phone Number', width: 150 },
    { field: 'email', headerName: 'Email Address', width: 160 },

    { field: 'status', headerName: 'Status', width: 140,
        renderCell:(params) => {
            return <div className={`cellstatus ${params.row.status}`}>{params.row.status} </div>
        },
    },
]




export const settingsColumns = [
 
    { field: 'firstname', headerName: 'Firstname', width: 150 },
    { field: 'lastname', headerName: 'Lastname', width: 150 },
    { field: 'email', headerName: 'Email ', width: 220 },
    { field: 'telephone', headerName: 'Telephone', width: 160 },
    { field: 'date', headerName: 'Reg Date', width: 160 },
    // { field: 'role', headerName: 'Role', width: 120 },

    { field: 'role', headerName: 'Role', width: 120,
        renderCell:(params) => {
            return  params.row.role === "adminAccess" ? "Admin" : params.row.role === "subadminAccess" ? "Sub Admin" : "Agency"
            // <span style={{color:'red'}}>{params.row.status}</span>
             
            
            
        },
    },

    { field: 'status', headerName: 'Status', width: 120,
        renderCell:(params) => {
            return  params.row.status === "active" ? <span style={{color:'green'}}>{params.row.status}</span>  : <span style={{color:'red'}}>{params.row.status}</span>
             
            
            
        },
    },
]


export const partnersColumns = [
 
    { field: 'partnername', headerName: 'Partners Name', width: 150 },
    
    { field: 'role', headerName: 'Parnter Role', width: 120,
        renderCell:(params) => {
            return  params.row.role === "admin" ? <span>Admin</span>  : <span>Member</span>
        },
    },
    { field: 'region', headerName: 'Partner City', width: 150 },
    { field: 'area', headerName: 'Partner Area', width: 150 },
    { field: 'partneraddress', headerName: 'Address', width: 150 },
    { field: 'email', headerName: 'Email ', width: 120 },
    { field: 'partnercode', headerName: 'Partner Code', width: 150 },
    { field: 'telephone', headerName: 'Telephone', width: 160 },
  
    { field: 'status', headerName: 'Status', width: 120,
        renderCell:(params) => {
            return  params.row.status === "active" ? <span style={{color:'green'}}>{params.row.status}</span>  : <span style={{color:'red'}}>{params.row.status}</span> 
        },
    },
]


export const engagmentAnalysisColumns = [
 
    { field: 'servicequalitystatus', headerName: 'Service Quality', width: 140 },
    { field: 'servicespeedstatus', headerName: 'Service Speed', width: 140 },
    { field: 'staffbehaviouralstatus', headerName: 'Staff Behaviour', width: 140 },
    { field: 'outletambiencestatus', headerName: 'Outlet Ambience', width: 160 },
    { field: 'valueaverageformoneystatus', headerName: 'Value for Money', width: 140 },
    { field: 'customeraveragereturnratestatus', headerName: 'Customer Return rate', width: 140 },
    { field: 'whatsappmessage', headerName: 'Whatsapp Message', width: 400 },

]


export const allRegions = [
    {
        key: 1, value: 'Abeokuta'
    },
    {
        key: 2, value: 'Abuja'
    },
    {
        key: 3, value: 'Asaba'
    },
    {
        key: 4, value: 'Benin'
    },
    {
        key: 5, value: 'Enugu'
    },
    {
        key: 6, value: 'Ibadan'
    },
    {
        key: 7, value: 'Jos'
    }, 
    {
        key: 8, value: 'Lagos'
    },
    {
        key: 9, value: 'Onitsha'
    },
    {
        key: 10, value: 'Owerri'
    },
    {
        key: 11, value: 'P/Harcourt'
    },
    {
        key: 12, value: 'Uyo'
    }, 
    {
        key: 13, value: 'Warri'
    },

]


export const allAreas = {

    "Abeokuta" : [

        {
        key: 0, value: 'Adatan',
        },
        {
            key: 1, value: 'Adigbe',
        },
        {
            key: 2, value: 'Ake', 
        },
        {
            key: 3, value: 'Alabata', 
        },
        {
            key: 4, value: 'Elega', 
        },
        {
            key: 5, value: 'Ibara', 
        },
        {
            key: 6, value: 'Idi-Aba', 
        },
        {
            key: 7, value: 'Ita Oshin', 
        }, 
        {
            key: 8, value: 'Itoku', 
        }, 
        {
            key: 9, value: 'Iyana Mortuary',
        },
        {
            key: 10, value: 'Kuto', 
        },
        {
            key: 11, value: 'Laderin', 
        },
        {
            key: 12, value: 'Lafenwa', 
        },
        {
            key: 13, value: 'Obantoko', 
        },
        {
            key: 14, value: 'Ojere', 
        },
        {
            key: 15, value: 'Oke-Ilewo', 
        },
        {
            key: 16, value: 'Olomore', 
        },
        {
            key: 17, value: 'Omida', 
        },
        {
            key: 18, value: 'Oshiele', 
        }, 
        {
            key: 19, value: 'Pansheke', 
        }, 
        {
            key: 20, value: 'Shapon', 
        },
    ],

    "Abuja" : [

    {
        key: 1, value: 'Airport Road', 
    },
    {
        key: 2, value: 'Apo',
    },
    {
        key: 3, value: 'Asokoro',
    },
    {
        key: 4, value: 'Central Business Dist', 
    },
    {
        key: 5, value: 'Dawaki', 
    },
    {
        key: 6, value: 'Durumi', 
    },
    {
        key: 7, value: 'Dutse', 
    }, 
    {
        key: 8, value: 'Galadimawa', 
    }, 
    {
        key: 9, value: 'Games Village', 
    },
    {
        key: 10, value: 'Garki', 
    },
    {
        key: 11, value: 'Guzape District', 
    },
    {
        key: 12, value: 'Gwagwalada', 
    },
    {
        key: 13, value: 'Gwarimpa', 
    },
    {
        key: 14, value: 'Idu', 
    },
    {
        key: 15, value: 'Jabi', 
    },
    {
        key: 16, value: 'Jahi', 
    },
    {
        key: 17, value: 'Kado', 
    },
    {
        key: 18, value: 'Karsana', 
    },
    {
        key: 19, value: 'Katampe', 
    }, 
    {
        key: 20, value: 'Katampe Ext.',
    }, 
    {
        key: 21, value: 'Kubwa', 
    },
    {
        key: 22, value: 'Kuje', 
    },
    {
        key: 23, value: 'Life Camp', 
    },
    {
        key: 24, value: 'Lokogoma',  
    },
    {
        key: 25, value: 'Lugbe',
    },
    {
        key: 26, value: 'Mabushi', 
    },
    {
        key: 27, value: 'Maitama', 
    },
    {
        key: 28, value: 'Mpape', 
    },
    {
        key: 29, value: 'Utako', 
    }, 
    {
        key: 30, value: 'Wuse 2.', 
    }
    , 
    {
        key: 31, value: 'Wuye', 
    },
    {
        key: 32, value: 'Zuba', 
    },
        

    ],


    "Asaba" : [

    {
        key: 1, value: '74 Road', 
    },
    {
        key: 2, value: 'Agric Road', 
    },
    {
        key: 3, value: 'Anwai Road', 
    },
    {
        key: 4, value: 'Asaba Specialist Hospital Road',
    },
    {
        key: 5, value: 'Bonsaac', 
    },
    {
        key: 6, value: 'DBS Road', 
    }, 
    {
        key: 7, value: 'DLA Road', 
    }, 
    {
        key: 8, value: 'Ezenei Avenue', 
    },
    {
        key: 9, value: 'Ibusa Road', 
    },
    {
        key: 10, value: 'Infant Jesus Road', 
    },
    {
        key: 11, value: 'Jesus Saves',
    },
    {
        key: 12, value: 'Koka Junction', 
    },
    {
        key: 13, value: 'Mariam Babangida Way', 
    },
    {
        key: 14, value: 'Midwifery Area',
    },
    {
        key: 15, value: 'Nnebisi Road', 
    },
    {
        key: 16, value: 'NTA Road', 
    },
    {
        key: 17, value: 'Okpanam Road', 
    }, 
    {
        key: 18, value: 'Okwe/Okoh Road', 
    }, 
    {
        key: 19, value: 'Summit Road', 
    },
    {
        key: 20, value: 'Traffic Light', 
    },


    ],


    "Benin" : [

    {
        key: 1, value: 'Aduwawa', 
    },
    {
        key: 2, value: 'Airport Road',
    },
    {
        key: 3, value: 'Akpakpava', 
    },
    {
        key: 4, value: 'Dawson Road', 
    },
    {
        key: 5, value: 'Ekewan Road', 
    },
    {
        key: 6, value: 'GRA', 
    }, 
    {
        key: 7, value: 'Ibiwe', 
    }, 
    {
        key: 8, value: 'Idokpa Auchi Bypass',
    },
    {
        key: 9, value: 'Ikpoba hill',
    },
    {
        key: 10, value: 'Iyaro', 
    },
    {
        key: 11, value: 'Mission Road', 
    },
    {
        key: 12, value: 'MM-Way', 
    },
    {
        key: 13, value: 'Okhoromi',
    },
    {
        key: 14, value: 'Ring Road', 
    },
    {
        key: 15, value: 'Sakpomba Road',
    },
    {
        key: 16, value: 'Sapele Road', 
    },
    {
        key: 17, value: 'Ugbor', 
    }, 
    {
        key: 18, value: 'Ugbowo', 
    }, 
    {
        key: 19, value: 'Upper Mission Ext.', 
    },
    {
        key: 20, value: 'Upper Sakpomba Road',
    },

    ],


    "Enugu" : [

    {
        key: 1, value: 'Abakpa', 
    },
    {
        key: 2, value: 'Achara Layout',
    },
    {
        key: 3, value: 'Agbani Road', 
    },
    {
        key: 4, value: 'Emene',
    },
    {
        key: 5, value: 'Garden Avenue',
    },
    {
        key: 6, value: 'Garriki',
    }, 
    {
        key: 7, value: 'GRA', 
    }, 
    {
        key: 8, value: 'Independence Layout', 
    },
    {
        key: 9, value: 'New Heaven', 
    },
    {
        key: 10, value: 'Old Artisan', 
    },
    {
        key: 11, value: 'Ogui', 
    },
    {
        key: 12, value: 'Trans-Ekulu', 
    },

    ],

    "Ibadan" : [
  
    {
        key: 1, value: 'Agodi Gate', 
    },
    {
        key: 2, value: 'Aiyegun', 
    },
    {
        key: 3, value: 'Akobo', 
    },
    {
        key: 4, value: 'Apata', 
    },
    {
        key: 5, value: 'Apete-Poly Road', 
    }, 
    {
        key: 6, value: 'Bodija', 
    }, 
    {
        key: 7, value: 'Challenge', 
    },
    {
        key: 6, value: 'Dugbe',
    },
    {
        key: 7, value: 'Eleyele', 
    },
    {
        key: 8, value: 'General Gas',
    },
    {
        key: 9, value: 'Iwo Road', 
    },
    {
        key: 10, value: 'Kolapo Ishola', 
    },
    {
        key: 11, value: 'Mobil Ring Road', 
    },
    {
        key: 12, value: 'Molete',
    },
    {
        key: 13, value: 'Moniya', 
    },
    {
        key: 14, value: 'New Garage', 
    }, 
    {
        key: 15, value: 'Odo-Ona Kekere', 
    }, 
    {
        key: 16, value: 'Ojoo', 
    },
    {
        key: 17, value: 'Olodo', 
    },
    {
        key: 18, value: 'Ologuneru',
    },
    {
        key: 19, value: 'Oomi', 
    },
    {
        key: 20, value: 'Owode-Olomi', 
    },
    {
        key: 21, value: 'Sango', 
    },
    {
        key: 22, value: 'Tipper Garrage', 
    },
    {
        key: 23, value: 'UI Ibadan', 
    }, 



    ],
    
    "Jos" : [

    {
        key: 1, value: 'Abattoir', 
    }, 
    {
        key: 2, value: 'Anguldi', 
    },
    {
        key: 3, value: 'Angwan Rukuba', 
    },
    {
        key: 4, value: 'Bukuru',
    },
    {
        key: 5, value: 'Busa Buji',
    },
    {
        key: 6, value: 'Farin Gada',
    },
    {
        key: 7, value: 'Fed. Low Cost', 
    },
    {
        key: 8, value: 'Gada Biu', 
    },
    {
        key: 9, value: 'Gyel', 
    },
    {
        key: 10, value: 'Mista Ali',
    },
    {
        key: 11, value: 'Nasarawa Gwon', 
    }, 
    {
        key: 12, value: 'Old Airport Road', 
    },
    {
        key: 13, value: 'Rantya', 
    },
    {
        key: 14, value: 'Rayfield', 
    },
    {
        key: 15, value: 'Rukuba Road', 
    },
    {
        key: 16, value: 'Tina', 
    },
    {
        key: 17, value: 'Utan',
    },

    ],
    
    "Lagos" : [

    {
        key: 1, value: 'Agege', 
    }, 
    {
        key: 2, value: 'Ajeromi-Ifelodun', 
    },
    {
        key: 3, value: 'Alimosho', 
    },
    {
        key: 4, value: 'Amuwo-Odofin', 
    },
    {
        key: 5, value: 'Apapa', 
    },
    {
        key: 6, value: 'Badagry', 
    },
    {
        key: 7, value: 'Epe', 
    },
    {
        key: 8, value: 'Eti-Osa', 
    },
    {
        key: 9, value: 'Ibeju Lekki', 
    },
    {
        key: 10, value: 'Ifako Ijaiye',
    }, 
    {
        key: 11, value: 'Ikeja',
    }
    , 
    {
        key: 12, value: 'Ikorodu', 
    },
  
    {
        key: 13, value: 'Kosofe', 
    },
    {
        key: 14, value: 'Lagos Island',
    },
    {
        key: 15, value: 'Lagos Mainland', 
    },
    {
        key: 16, value: 'Mushin',
    },
    {
        key: 17, value: 'Ojo', 
    },
    {
        key: 18, value: 'Oshodi-Isolo', 
    },
    {
        key: 19, value: 'Somolu', 
    }, 
    {
        key: 20, value: 'Surulere', 
    }
   
    ],

    "Onitsha" : [


    {
        key: 1, value: 'Akwa Road', 
    },
    {
        key: 2, value: 'Fegge', 
    },
    {
        key: 3, value: 'Federal Housing', 
    },
    {
        key: 4, value: 'GRA', 
    },
    {
        key: 5, value: 'Nkpor', 
    }, 
    {
        key: 6, value: 'Oba', 
    }
    , 
    {
        key: 7, value: 'Obosi',
    },
  
    {
        key: 8, value: 'Obudu Ukwu', 
    },
    {
        key: 9, value: 'Odoapku', 
    },
    {
        key: 10, value: 'Ogbaru', 
    },
    {
        key: 11, value: 'Okpoko', 
    },
    {
        key: 12, value: 'Omagba Phase 1',
    },
    {
        key: 13, value: 'Omagba Phase 2', 
    },
    {
        key: 14, value: 'Three-Three',
    }, 
    {
        key: 15, value: 'Trans-Nkisi', 
    },
    

    ],

    "Owerri" : [

    {
        key: 1, value: 'Amakaohia', 
    },
    {
        key: 2, value: 'Douglas Road', 
    },
    {
        key: 3, value: 'Egbu',
    },
    {
        key: 4, value: 'Ikenegbu',
    },
    {
        key: 5, value: 'Irete', 
    },
    {
        key: 6, value: 'MCC/Uratta', 
    },
    {
        key: 7, value: 'Naze', 
    },
    {
        key: 8, value: 'Nekede', 
    }, 
    {
        key: 9, value: 'Orji', 
    },
    {
        key: 10, value: 'Wethdral Road', 
    },
    {
        key: 11, value: 'Works Layout', 
    },
    {
        key: 12, value: 'World Bank', 
    }, 
    {
        key: 13, value: 'Abuloma', 
    },

    ],

    "P/Harcourt" : [

    {
        key: 1, value: 'Ada George', 
    },
    {
        key: 2, value: 'Akpajio', 
    },
    {
        key: 3, value: 'Bonny', 
    },
    {
        key: 4, value: 'Borokiri', 
    },
    {
        key: 5, value: 'Chobah', 
    },
    {
        key: 6, value: 'Diodu', 
    },
    {
        key: 7, value: 'D-Line', 
    }, 
    {
        key: 8, value: 'Elekhaia', 
    }, 
    {
        key: 9, value: 'Elelenwon', 
    },
    {
        key: 10, value: 'Eleme',
    },
    {
        key: 11, value: 'Eliozu Road', 
    },
    {
        key: 12, value: 'Eneka', 
    },
    {
        key: 13, value: 'GRA Phase 1', 
    },
    {
        key: 14, value: 'GRA Phase 2', 
    },
    {
        key: 15, value: 'Igwurita',
    },
    {
        key: 16, value: 'Iwofe', 
    },
    {
        key: 17, value: 'Ogbunabali Road', 
    },
    {
        key: 18, value: 'Old GRA', 
    }, 
    {
        key: 19, value: 'Rainbow Town', 
    },
    {
        key: 20, value: 'Rumudara',
    },
    {
        key: 21, value: 'Rumuigbo',
    },
    {
        key: 22, value: 'Rumuokoro',
    },
    {
        key: 23, value: 'Rumuola', 
    },
    {
        key: 24, value: 'Rumuomasi', 
    },
    {
        key: 25, value: 'Trans-Amadi', 
    }, 
    {
        key: 26, value: 'Woji', 
    },

    ],

    "Uyo" : [

    {
        key: 1, value: '2 Lane',
    },
    {
        key: 2, value: '4 Lane', 
    },
    {
        key: 3, value: 'Abak Road', 
    },
    {
        key: 4, value: 'Aka Road', 
    },
    {
        key: 5, value: 'Atiku Abubakar', 
    },
    {
        key: 6, value: 'Barrack Road', 
    },
    {
        key: 7, value: 'Brooks Street', 
    },
    {
        key: 8, value: 'IBB', 
    },
    {
        key: 9, value: 'Idoro Road', 
    },
    {
        key: 10, value: 'Ikot Ekpene Road', 
    },
    {
        key: 11, value: 'Itam', 
    },
    {
        key: 12, value: 'Nepa Line', 
    },
    {
        key: 13, value: 'Nung Udoe Road', 
    },
    {
        key: 14, value: 'Nwaniba Road', 
    },
    {
        key: 15, value: 'Obio Imoh/Aka Road', 
    },
    {
        key: 16, value: 'Oron Road', 
    },
    {
        key: 17, value: 'Oron Road/Airport Road', 
    },
    {
        key: 18, value: 'Ring Road 1', 
    },
    {
        key: 19, value: 'Ring Road 2', 
    },
    {
        key: 20, value: 'Ring Road 3',
    },
    {
        key: 21, value: 'Stadium Road', 
    },
    {
        key: 22, value: 'Udoudoma', 
    },
    {
        key: 23, value: 'Urua Ekpa', 
    },
    {
        key: 24, value: 'Uruan Street', 
    },

    ],

    "Warri" : [

    {
        key: 1, value: 'Airport Road',
    },
    {
        key: 2, value: 'Ajamimogha', 
    },
    {
        key: 3, value: 'DSC', 
    },
    {
        key: 4, value: 'Effurun', 
    },
    {
        key: 5, value: 'Edjeba', 
    },
    {
        key: 6, value: 'Ekpan', 
    },
    {
        key: 7, value: 'Eneren', 
    },
    {
        key: 8, value: 'Garage', 
    },
    {
        key: 9, value: 'GRA', 
    },
    {
        key: 10, value: 'Jakpa',
    },
    {
        key: 11, value: 'Osubi',
    },
    {
        key: 12, value: 'PTI', 
    },
    {
        key: 13, value: 'Ukpoloposo', 
    },
  


    ]

}


export const allOutlets = {


    // ABEOKUTA

    "Adatan" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Adigbe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ake" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Alabata" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
    "Elega" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Eabata" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ibara" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Idi-Aba" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ita Osh" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Itokuta Osh" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Itoku" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Iyana Mortuary" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Kuto" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Laderino" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Lafenwa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Obantoko" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


     "Ojeko" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ojere" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Oke-Ilewo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Olomore" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Omida" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Oshiele" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Pansheke" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

       "Shapon" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],






///////  ABUJA



    "Airport Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Apo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Asokoro" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Central Business Dist" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Dawaki" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Durumi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Dutse" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Galadimawah" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Games Village" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Garki" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Guzape District" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Gwagwalada" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Gwarimpa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Idu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Jabi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


     "Jahi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Kado" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Karsana" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Katampe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Katampe Ext." : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Kubwa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Kuje" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Life Camp" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
    "Lokogoma" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Lugbe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
     "Mabushi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Maitama" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
     "Mpape" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Utako" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
     "Wuse 2" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

       "Wuye" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
     "Zuba" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


    //// ASABA

     

    "74 Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Agric Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Anwai Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Asaba Specialist Hospital Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Bonsaac" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "DBS Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "DLA Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ezenei Avenue" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ibusa Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Infant Jesus Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Jesus Saves" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Koka Junction" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Mariam Babangida Way" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Midwifery Area" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Nnebisi Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


     "NTA Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Okpanam Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Okwe/Okoh Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Summit Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Traffic Light" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


    ///BENIN

   
    "Aduwawa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Airport Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Akpakpava" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Dawson Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ekewan Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "GRA" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ibiwe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Idokpa Auchi Bypass" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ikpoba hill" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Iyaro" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Mission Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "MM-Way" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Okhoromi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ring Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Sakpomba Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Sapele Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ugbor" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ugbowo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Upper Mission Ext." : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Upper Sakpomba Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


/// ENUGU




    "Abakpa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Achara Layout" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Agbani Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Emene" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Garden Avenue" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Garriki" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "GRA" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Independence Layout" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "New Heaven" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Old Artisan" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Ogui" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Trans-Ekulu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


//// IBADAN//////


    "Agodi Gate" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Aiyegun" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Akobo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Apata" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Apete-Poly Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Bodija" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Challenge" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Dugbe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Eleyele" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "General Gas" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Iwo Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Kolapo Ishola" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Mobil Ring Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Molete" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Moniya" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "New Garage" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Odo-Ona Kekere" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Ojoo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Olodo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
     "Ologuneru" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Oomi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Owode-Olomi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Sango" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "Tipper Garrage" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

      "UI Ibadanoo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


//// JOS


    "Abattoir" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Anguldi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Angwan Rukuba" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Bukuru" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Busa Bujid" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Farin Gada" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Fed. Low Coste" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Gada Biu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Gyel" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Mista Ali" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Nasarawa Gwon" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Old Airport Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Rantya" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Rayfield" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Rukuba Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Tina" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Utan" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],



    //// LAGOS


    "Agege" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ajeromi-Ifelodun" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Alimosho" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Amuwo-Odofin" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Apapa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Badagry" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Epe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Eti-Osa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ibeju Lekki" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ifako Ijaiye" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ikeja" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ikorodu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Kosofe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Lagos Island" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Lagos Mainland" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Mushin" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ojo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
    "Oshodi-Isolo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Somolu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Surulere" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


    /// ONITSHA



    "Akwa Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Fegge" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Federal Housing" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "GRA" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Nkpor" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Oba" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Obosi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Obudu Ukwu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Odoapku" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ogbaru" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Okpoko" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Omagba Phase 1" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Omagba Phase 2" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Three-Three" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
     "Trans-Nkisi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],



/// OWERRI


    "Amakaohia" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Douglas Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Egbu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ikenegbu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Irete" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "MCC/Uratta" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Naze" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Nekede" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Orji" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Wethdral Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Works Layout" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "World Bank" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Abuloma" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


    // "P/HARCOURT



    "Ada George" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Akpajio" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Bonny" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Borokiri" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Chobah" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Diodu" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "D-Line" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Elekhaia" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Elelenwon" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Eleme" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Eliozu Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Eneka" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "GRA Phase 1" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
    
    "GRA Phase 2" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Igwurita" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Iwofe" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ogbunabali Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Old GRA" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Rainbow Town" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Rumudara" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Rumuigbo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Rumuokoro" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Rumuola" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Rumuomasi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Trans-Amadi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Woji" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


    /// UYO  ///



    "2 Lane" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "4 Lane" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Abak Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Aka Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Atiku Abubakar" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Barrack Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Brooks Street" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "IBB" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Idoro Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ikot Ekpene Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Itam" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Nepa Line" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Nung Udoe Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],
    
    "Nwaniba Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Obio Imoh/Aka Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Oron Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Oron Road/Airport Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Ring Road 1" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ring Road 2" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ring Road 3" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Stadium Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Udoudoma" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Urua Ekpa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Uruan Street" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],


    // WARRI



    "Airport Road" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ajamimogha" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "DSC" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Effurun" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Edjeba" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ekpan" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Eneren" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "Garage" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

     "GRA" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Jakpa" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Osubi" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "PTI" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

    "Ukpoloposo" : [

        {
        key: 1, value: 'Bar'
        },
        {
            key: 2, value: 'Beach'
        },
        {
            key: 3, value: 'Event Center'
        },
        {
            key: 4, value: 'Hotel'
        },
        {
            key: 5, value: 'Lounge'
        },
        {
            key: 6, value: 'Night Club'
        },
        {
            key: 7, value: 'Restaurant'
        }, 
        {
            key: 8, value: 'Service Apartment' 
        }

    ],

}



// export const allOutlet = [
//     {
//         key: 1, value: 'Bar'
//     },
//     {
//         key: 2, value: 'Beach'
//     },
//     {
//         key: 3, value: 'Event Center'
//     },
//     {
//         key: 4, value: 'Hotel'
//     },
//     {
//         key: 5, value: 'Lounge'
//     },
//     {
//         key: 6, value: 'Night Club'
//     },
//     {
//         key: 7, value: 'Restaurant'
//     }, 
//     {
//         key: 8, value: 'Service Apartment' 
//     }

// ]

// export const regions = [
//     {
//         key: 1, value: 'Abeokuta'
//     },
//     {
//         key: 2, value: 'Abuja'
//     },
//     {
//         key: 3, value: 'Asaba'
//     },
//     {
//         key: 4, value: 'Benin'
//     },
//     {
//         key: 5, value: 'Enugu'
//     },
//     {
//         key: 6, value: 'Ibadan'
//     },
//     {
//         key: 7, value: 'Jos'
//     }, 
//     {
//         key: 8, value: 'Lagos'
//     },
//     {
//         key: 9, value: 'Onitsha'
//     },
//     {
//         key: 10, value: 'Owerri'
//     },
//     {
//         key: 11, value: 'P/Harcourt'
//     },
//     {
//         key: 12, value: 'Uyo'
//     }, 
//     {
//         key: 13, value: 'Warri'
//     },

// ]


// export const areas = [
//     {
//         key: 0, value: 'Adatan', statekey: 'Abeokuta'
//     },
//     {
//         key: 1, value: 'Adigbe', statekey: 'Abeokuta' 
//     },
//     {
//         key: 2, value: 'Ake', statekey: 'Abeokuta'
//     },
//     {
//         key: 3, value: 'Alabata', statekey: 'Abeokuta'
//     },
//     {
//         key: 4, value: 'Elega', statekey: 'Abeokuta'
//     },
//     {
//         key: 5, value: 'Ibara', statekey: 'Abeokuta'
//     },
//     {
//         key: 6, value: 'Idi-Aba', statekey: 'Abeokuta'
//     },
//     {
//         key: 7, value: 'Ita Oshin', statekey: 'Abeokuta'
//     }, 
//     {
//         key: 8, value: 'Itoku', statekey: 'Abeokuta'
//     }
//     , 
//     {
//         key: 9, value: 'Iyana Mortuary', statekey: 'Abeokuta'
//     },
//     {
//         key: 10, value: 'Kuto', statekey: 'Abeokuta'
//     },
//     {
//         key: 11, value: 'Laderin', statekey: 'Abeokuta'
//     },
//     {
//         key: 12, value: 'Lafenwa', statekey: 'Abeokuta'
//     },
//     {
//         key: 13, value: 'Obantoko', statekey: 'Abeokuta' 
//     },
//     {
//         key: 14, value: 'Ojere', statekey: 'Abeokuta'
//     },
//     {
//         key: 15, value: 'Oke-Ilewo', statekey: 'Abeokuta'
//     },
//     {
//         key: 16, value: 'Olomore', statekey: 'Abeokuta'
//     },
//     {
//         key: 17, value: 'Omida', statekey: 'Abeokuta'
//     },
//     {
//         key: 18, value: 'Oshiele', statekey: 'Abeokuta'
//     }, 
//     {
//         key: 19, value: 'Pansheke', statekey: 'Abeokuta'
//     }, 
//     {
//         key: 20, value: 'Shapon', statekey: 'Abeokuta'
//     },
  
//     {
//         key: 21, value: 'Airport Road', statekey: 'Abuja' 
//     },
//     {
//         key: 22, value: 'Apo', statekey: 'Abuja'
//     },
//     {
//         key: 23, value: 'Asokoro', statekey: 'Abuja'
//     },
//     {
//         key: 24, value: 'Central Business Dist', statekey: 'Abuja'
//     },
//     {
//         key: 25, value: 'Dawaki', statekey: 'Abuja'
//     },
//     {
//         key: 26, value: 'Durumi', statekey: 'Abuja'
//     },
//     {
//         key: 27, value: 'Dutse', statekey: 'Abuja'
//     }, 
//     {
//         key: 28, value: 'Galadimawa', statekey: 'Abuja'
//     }
//     , 
//     {
//         key: 29, value: 'Games Village', statekey: 'Abuja'
//     },
//     {
//         key: 30, value: 'Garki', statekey: 'Abuja'
//     },
//     {
//         key: 31, value: 'Guzape District', statekey: 'Abuja'
//     },
//     {
//         key: 256, value: 'Gwagwalada', statekey: 'Abuja'
//     },
//     {
//         key: 32, value: 'Gwarimpa', statekey: 'Abuja'
//     },
//     {
//         key: 33, value: 'Idu', statekey: 'Abuja' 
//     },
//     {
//         key: 34, value: 'Jabi', statekey: 'Abuja'
//     },
//     {
//         key: 35, value: 'Jahi', statekey: 'Abuja'
//     },
//     {
//         key: 36, value: 'Kado', statekey: 'Abuja'
//     },
//     {
//         key: 37, value: 'Karsana', statekey: 'Abuja'
//     },
//     {
//         key: 38, value: 'Katampe', statekey: 'Abuja'
//     }, 
//     {
//         key: 39, value: 'Katampe Ext.', statekey: 'Abuja'
//     }
//     , 
//     {
//         key: 40, value: 'Kubwa', statekey: 'Abuja'
//     },
//     {
//         key: 41, value: 'Kuje', statekey: 'Abuja'
//     },
//     {
//         key: 42, value: 'Life Camp', statekey: 'Abuja'
//     },
//     {
//         key: 43, value: 'Lokogoma', statekey: 'Abuja' 
//     },
//     {
//         key: 44, value: 'Lugbe', statekey: 'Abuja'
//     },
//     {
//         key: 45, value: 'Mabushi', statekey: 'Abuja'
//     },
//     {
//         key: 46, value: 'Maitama', statekey: 'Abuja'
//     },
//     {
//         key: 47, value: 'Mpape', statekey: 'Abuja'
//     },
//     {
//         key: 48, value: 'Utako', statekey: 'Abuja'
//     }, 
//     {
//         key: 49, value: 'Wuse 2.', statekey: 'Abuja'
//     }
//     , 
//     {
//         key: 50, value: 'Wuye', statekey: 'Abuja'
//     },
//     {
//         key: 51, value: 'Zuba', statekey: 'Abuja'
//     },
//     {
//         key: 52, value: '74 Road', statekey: 'Asaba'
//     },
//     {
//         key: 53, value: 'Agric Road', statekey: 'Asaba'
//     },
//     {
//         key: 54, value: 'Anwai Road', statekey: 'Asaba'
//     },
//     {
//         key: 55, value: 'Asaba Specialist Hospital Road', statekey: 'Asaba'
//     },
//     {
//         key: 56, value: 'Bonsaac', statekey: 'Asaba'
//     },
//     {
//         key: 57, value: 'DBS Road', statekey: 'Asaba'
//     }, 
//     {
//         key: 58, value: 'DLA Road', statekey: 'Asaba'
//     }
//     , 
//     {
//         key: 59, value: 'Ezenei Avenue', statekey: 'Asaba'
//     },
//     {
//         key: 60, value: 'Ibusa Road', statekey: 'Asaba'
//     },
//     {
//         key: 61, value: 'Infant Jesus Road', statekey: 'Asaba'
//     },
//     {
//         key: 62, value: 'Jesus Saves', statekey: 'Asaba'
//     },
//     {
//         key: 63, value: 'Koka Junction', statekey: 'Asaba' 
//     },
//     {
//         key: 64, value: 'Mariam Babangida Way', statekey: 'Asaba'
//     },
//     {
//         key: 65, value: 'Midwifery Area', statekey: 'Asaba'
//     },
//     {
//         key: 66, value: 'Nnebisi Road', statekey: 'Asaba'
//     },
//     {
//         key: 67, value: 'NTA Road', statekey: 'Asaba'
//     },
//     {
//         key: 68, value: 'Okpanam Road', statekey: 'Asaba'
//     }, 
//     {
//         key: 69, value: 'Okwe/Okoh Road', statekey: 'Asaba'
//     }, 
//     {
//         key: 70, value: 'Summit Road', statekey: 'Asaba'
//     },
//     {
//         key: 71, value: 'Traffic Light', statekey: 'Asaba'
//     },
//     {
//         key: 72, value: 'Aduwawa', statekey: 'Benin'
//     },
//     {
//         key: 73, value: 'Airport Road', statekey: 'Benin'
//     },
//     {
//         key: 74, value: 'Akpakpava', statekey: 'Benin'
//     },
//     {
//         key: 75, value: 'Dawson Road', statekey: 'Benin'
//     },
//     {
//         key: 76, value: 'Ekewan Road', statekey: 'Benin'
//     },
//     {
//         key: 77, value: 'GRA', statekey: 'Benin'
//     }, 
//     {
//         key: 78, value: 'Ibiwe', statekey: 'Benin'
//     }, 
//     {
//         key: 79, value: 'Idokpa Auchi Bypass', statekey: 'Benin'
//     },
//     {
//         key: 80, value: 'Ikpoba hill', statekey: 'Benin'
//     },
//     {
//         key: 81, value: 'Iyaro', statekey: 'Benin'
//     },
//     {
//         key: 82, value: 'Mission Road', statekey: 'Benin'
//     },
//     {
//         key: 83, value: 'MM-Way', statekey: 'Benin' 
//     },
//     {
//         key: 84, value: 'Okhoromi', statekey: 'Benin'
//     },
//     {
//         key: 85, value: 'Ring Road', statekey: 'Benin'
//     },
//     {
//         key: 86, value: 'Sakpomba Road', statekey: 'Benin'
//     },
//     {
//         key: 87, value: 'Sapele Road', statekey: 'Benin'
//     },
//     {
//         key: 88, value: 'Ugbor', statekey: 'Benin'
//     }, 
//     {
//         key: 89, value: 'Ugbowo', statekey: 'Benin'
//     }
//     , 
//     {
//         key: 90, value: 'Upper Mission Ext.', statekey: 'Benin'
//     },
//     {
//         key: 91, value: 'Upper Sakpomba Road', statekey: 'Benin'
//     },
//     {
//         key: 92, value: 'Abakpa', statekey: 'Enugu'
//     },
//     {
//         key: 93, value: 'Achara Layout', statekey: 'Enugu'
//     },
//     {
//         key: 94, value: 'Agbani Road', statekey: 'Enugu'
//     },
//     {
//         key: 95, value: 'Emene', statekey: 'Enugu'
//     },
//     {
//         key: 96, value: 'Garden Avenue', statekey: 'Enugu'
//     },
//     {
//         key: 97, value: 'Garriki', statekey: 'Enugu'
//     }, 
//     {
//         key: 98, value: 'GRA', statekey: 'Enugu'
//     }
//     , 
//     {
//         key: 99, value: 'Independence Layout', statekey: 'Enugu'
//     },
//     {
//         key: 100, value: 'New Heaven', statekey: 'Enugu'
//     },
//     {
//         key: 101, value: 'Old Artisan', statekey: 'Enugu'
//     },
//     {
//         key: 102, value: 'Ogui', statekey: 'Enugu'
//     },
//     {
//         key: 103, value: 'Trans-Ekulu', statekey: 'Enugu' 
//     },
//     {
//         key: 104, value: 'Agodi Gate', statekey: 'Ibadan'
//     },
//     {
//         key: 105, value: 'Aiyegun', statekey: 'Ibadan'
//     },
//     {
//         key: 106, value: 'Akobo', statekey: 'Ibadan'
//     },
//     ,
//     {
//         key: 257, value: 'Apata', statekey: 'Ibadan'
//     },
//     {
//         key: 107, value: 'Apete-Poly Road', statekey: 'Ibadan'
//     }, 
//     {
//         key: 108, value: 'Bodija', statekey: 'Ibadan'
//     }, 
//     {
//         key: 109, value: 'Challenge', statekey: 'Ibadan'
//     },
//     {
//         key: 110, value: 'Dugbe', statekey: 'Ibadan'
//     },
//     {
//         key: 111, value: 'Eleyele', statekey: 'Ibadan'
//     },
//     {
//         key: 112, value: 'General Gas', statekey: 'Ibadan'
//     },
//     {
//         key: 113, value: 'Iwo Road', statekey: 'Ibadan' 
//     },
//     {
//         key: 114, value: 'Kolapo Ishola', statekey: 'Ibadan'
//     },
//     {
//         key: 115, value: 'Mobil Ring Road', statekey: 'Ibadan'
//     },
//     {
//         key: 116, value: 'Molete', statekey: 'Ibadan'
//     },
//     {
//         key: 117, value: 'Moniya', statekey: 'Ibadan'
//     },
//     {
//         key: 118, value: 'New Garage', statekey: 'Ibadan'
//     }, 
//     {
//         key: 119, value: 'Odo-Ona Kekere', statekey: 'Ibadan'
//     }
//     , 
//     {
//         key: 120, value: 'Ojoo', statekey: 'Ibadan'
//     },
  
//     {
//         key: 121, value: 'Olodo', statekey: 'Ibadan' 
//     },
//     {
//         key: 122, value: 'Ologuneru', statekey: 'Ibadan'
//     },
//     {
//         key: 123, value: 'Oomi', statekey: 'Ibadan'
//     },
//     {
//         key: 124, value: 'Owode-Olomi', statekey: 'Ibadan'
//     },
//     {
//         key: 125, value: 'Sango', statekey: 'Ibadan'
//     },
//     {
//         key: 126, value: 'Tipper Garrage', statekey: 'Ibadan'
//     },
//     {
//         key: 127, value: 'UI Ibadan', statekey: 'Ibadan'
//     }, 
//     {
//         key: 128, value: 'Abattoir', statekey: 'Jos'
//     }
//     , 
//     {
//         key: 129, value: 'Anguldi', statekey: 'Jos'
//     },
//     {
//         key: 130, value: 'Angwan Rukuba', statekey: 'Jos'
//     },
//     {
//         key: 131, value: 'Bukuru', statekey: 'Jos'
//     },
//     {
//         key: 132, value: 'Busa Buji', statekey: 'Jos'
//     },
//     {
//         key: 133, value: 'Farin Gada', statekey: 'Jos' 
//     },
//     {
//         key: 134, value: 'Fed. Low Cost', statekey: 'Jos'
//     },
//     {
//         key: 135, value: 'Gada Biu', statekey: 'Jos'
//     },
//     {
//         key: 136, value: 'Gyel', statekey: 'Jos'
//     },
//     {
//         key: 137, value: 'Mista Ali', statekey: 'Jos'
//     },
//     {
//         key: 138, value: 'Nasarawa Gwon', statekey: 'Jos'
//     }, 
//     {
//         key: 139, value: 'Old Airport Road', statekey: 'Jos'
//     },
//     {
//         key: 140, value: 'Rantya', statekey: 'Jos' 
//     },
//     {
//         key: 141, value: 'Rayfield', statekey: 'Jos'
//     },
//     {
//         key: 142, value: 'Rukuba Road', statekey: 'Jos'
//     },
//     {
//         key: 143, value: 'Tina', statekey: 'Jos'
//     },
//     {
//         key: 144, value: 'Utan', statekey: 'Jos'
//     },
//     {
//         key: 145, value: 'Agege', statekey: 'Lagos'
//     }, 
//     {
//         key: 146, value: 'Ajeromi-Ifelodun', statekey: 'Lagos'
//     },
//     {
//         key: 147, value: 'Alimosho', statekey: 'Lagos'
//     },
//     {
//         key: 148, value: 'Amuwo-Odofin', statekey: 'Lagos'
//     },
//     {
//         key: 149, value: 'Apapa', statekey: 'Lagos' 
//     },
//     {
//         key: 150, value: 'Badagry', statekey: 'Lagos'
//     },
//     {
//         key: 151, value: 'Epe', statekey: 'Lagos'
//     },
//     {
//         key: 152, value: 'Eti-Osa', statekey: 'Lagos'
//     },
//     {
//         key: 153, value: 'Ibeju Lekki', statekey: 'Lagos'
//     },
//     {
//         key: 154, value: 'Ifako Ijaiye', statekey: 'Lagos'
//     }, 
//     {
//         key: 155, value: 'Ikeja', statekey: 'Lagos'
//     }
//     , 
//     {
//         key: 156, value: 'Ikorodu', statekey: 'Lagos'
//     },
  
//     {
//         key: 157, value: 'Kosofe', statekey: 'Lagos' 
//     },
//     {
//         key: 158, value: 'Lagos Island', statekey: 'Lagos'
//     },
//     {
//         key: 159, value: 'Lagos Mainland', statekey: 'Lagos'
//     },
//     {
//         key: 160, value: 'Mushin', statekey: 'Lagos'
//     },
//     {
//         key: 161, value: 'Ojo', statekey: 'Lagos'
//     },
//     {
//         key: 162, value: 'Oshodi-Isolo', statekey: 'Lagos'
//     },
//     {
//         key: 163, value: 'Somolu', statekey: 'Lagos'
//     }, 
//     {
//         key: 164, value: 'Surulere', statekey: 'Lagos'
//     }
//     , 
//     {
//         key: 165, value: 'Akwa Road', statekey: 'Onitsha'
//     },
//     {
//         key: 166, value: 'Fegge', statekey: 'Onitsha'
//     },
//     {
//         key: 167, value: 'Federal Housing', statekey: 'Onitsha'
//     },
//     {
//         key: 168, value: 'GRA', statekey: 'Onitsha'
//     },
//     {
//         key: 169, value: 'Nkpor', statekey: 'Onitsha'
//     }, 
//     {
//         key: 170, value: 'Oba', statekey: 'Onitsha'
//     }
//     , 
//     {
//         key: 171, value: 'Obosi', statekey: 'Onitsha'
//     },
  
//     {
//         key: 172, value: 'Obudu Ukwu', statekey: 'Onitsha' 
//     },
//     {
//         key: 173, value: 'Odoapku', statekey: 'Onitsha'
//     },
//     {
//         key: 174, value: 'Ogbaru', statekey: 'Onitsha'
//     },
//     {
//         key: 175, value: 'Okpoko', statekey: 'Onitsha'
//     },
//     {
//         key: 176, value: 'Omagba Phase 1', statekey: 'Onitsha'
//     },
//     {
//         key: 177, value: 'Omagba Phase 2', statekey: 'Onitsha'
//     },
//     {
//         key: 178, value: 'Three-Three', statekey: 'Onitsha'
//     }, 
//     {
//         key: 179, value: 'Trans-Nkisi', statekey: 'Onitsha'
//     },
//     {
//         key: 180, value: 'Amakaohia', statekey: 'Owerri'
//     },
//     {
//         key: 181, value: 'Douglas Road', statekey: 'Owerri'
//     },
//     {
//         key: 182, value: 'Egbu', statekey: 'Owerri'
//     },
//     {
//         key: 183, value: 'Ikenegbu', statekey: 'Owerri' 
//     },
//     {
//         key: 184, value: 'Irete', statekey: 'Owerri'
//     },
//     {
//         key: 185, value: 'MCC/Uratta', statekey: 'Owerri'
//     },
//     {
//         key: 186, value: 'Naze', statekey: 'Owerri'
//     },
//     {
//         key: 187, value: 'Nekede', statekey: 'Owerri'
//     }, 
//     {
//         key: 188, value: 'Orji', statekey: 'Owerri'
//     },
//     {
//         key: 189, value: 'Wethdral Road', statekey: 'Owerri'
//     },
//     {
//         key: 190, value: 'Works Layout', statekey: 'Owerri'
//     },
//     {
//         key: 191, value: 'World Bank', statekey: 'Owerri'
//     }, 
//     {
//         key: 192, value: 'Abuloma', statekey: 'P/Harcourt'
//     },
  
//     {
//         key: 193, value: 'Ada George', statekey: 'P/Harcourt' 
//     },
//     {
//         key: 194, value: 'Akpajio', statekey: 'P/Harcourt'
//     },
//     {
//         key: 195, value: 'Bonny', statekey: 'P/Harcourt'
//     },
//     {
//         key: 196, value: 'Borokiri', statekey: 'P/Harcourt'
//     },
//     {
//         key: 197, value: 'Chobah', statekey: 'P/Harcourt'
//     },
//     {
//         key: 198, value: 'Diodu', statekey: 'P/Harcourt'
//     },
//     {
//         key: 199, value: 'D-Line', statekey: 'P/Harcourt'
//     }, 
//     {
//         key: 200, value: 'Elekhaia', statekey: 'P/Harcourt'
//     }
//     , 
//     {
//         key: 201, value: 'Elelenwon', statekey: 'P/Harcourt'
//     },
//     {
//         key: 202, value: 'Eleme', statekey: 'P/Harcourt'
//     },
//     {
//         key: 203, value: 'Eliozu Road', statekey: 'P/Harcourt'
//     },
//     {
//         key: 204, value: 'Eneka', statekey: 'P/Harcourt'
//     },
//     {
//         key: 205, value: 'GRA Phase 1', statekey: 'P/Harcourt' 
//     },
//     {
//         key: 206, value: 'GRA Phase 2', statekey: 'P/Harcourt'
//     },
//     {
//         key: 207, value: 'Igwurita', statekey: 'P/Harcourt'
//     },
//     {
//         key: 208, value: 'Iwofe', statekey: 'P/Harcourt'
//     },
//     {
//         key: 209, value: 'Ogbunabali Road', statekey: 'P/Harcourt'
//     },
//     {
//         key: 210, value: 'Old GRA', statekey: 'P/Harcourt'
//     }, 
//     {
//         key: 211, value: 'Rainbow Town', statekey: 'P/Harcourt'
//     },
//     {
//         key: 212, value: 'Rumudara', statekey: 'P/Harcourt' 
//     },
//     {
//         key: 213, value: 'Rumuigbo', statekey: 'P/Harcourt'
//     },
//     {
//         key: 214, value: 'Rumuokoro', statekey: 'P/Harcourt'
//     },
//     {
//         key: 215, value: 'Rumuola', statekey: 'P/Harcourt'
//     },
//     {
//         key: 216, value: 'Rumuomasi', statekey: 'P/Harcourt'
//     },
//     {
//         key: 217, value: 'Trans-Amadi', statekey: 'P/Harcourt'
//     }, 
//     {
//         key: 218, value: 'Woji', statekey: 'P/Harcourt'
//     },
//     {
//         key: 219, value: '2 Lane', statekey: 'Uyo'
//     },
//     {
//         key: 220, value: '4 Lane', statekey: 'Uyo'
//     },
//     {
//         key: 221, value: 'Abak Road', statekey: 'Uyo' 
//     },
//     {
//         key: 222, value: 'Aka Road', statekey: 'Uyo'
//     },
//     {
//         key: 223, value: 'Atiku Abubakar', statekey: 'Uyo'
//     },
//     {
//         key: 224, value: 'Barrack Road', statekey: 'Uyo' 
//     },
//     {
//         key: 225, value: 'Brooks Street', statekey: 'Uyo'
//     },
//     {
//         key: 226, value: 'IBB', statekey: 'Uyo'
//     },
//     {
//         key: 227, value: 'Idoro Road', statekey: 'Uyo' 
//     },
//     {
//         key: 228, value: 'Ikot Ekpene Road', statekey: 'Uyo'
//     },
//     {
//         key: 229, value: 'Itam', statekey: 'Uyo'
//     },
//     {
//         key: 230, value: 'Nepa Line', statekey: 'Uyo' 
//     },
//     {
//         key: 231, value: 'Nung Udoe Road', statekey: 'Uyo'
//     },
//     {
//         key: 232, value: 'Nwaniba Road', statekey: 'Uyo'
//     },
//     {
//         key: 233, value: 'Obio Imoh/Aka Road', statekey: 'Uyo' 
//     },
//     {
//         key: 234, value: 'Oron Road', statekey: 'Uyo'
//     },
//     {
//         key: 235, value: 'Oron Road/Airport Road', statekey: 'Uyo'
//     },
//     {
//         key: 236, value: 'Ring Road 1', statekey: 'Uyo' 
//     },
//     {
//         key: 237, value: 'Ring Road 2', statekey: 'Uyo'
//     },
//     {
//         key: 238, value: 'Ring Road 3', statekey: 'Uyo'
//     },
//     {
//         key: 239, value: 'Stadium Road', statekey: 'Uyo' 
//     },
//     {
//         key: 240, value: 'Udoudoma', statekey: 'Uyo'
//     },
//     {
//         key: 241, value: 'Urua Ekpa', statekey: 'Uyo'
//     },
//     {
//         key: 242, value: 'Uruan Street', statekey: 'Uyo' 
//     },
//     {
//         key: 243, value: 'Airport Road', statekey: 'Warri' 
//     },
//     {
//         key: 244, value: 'Ajamimogha', statekey: 'Warri'
//     },
//     {
//         key: 245, value: 'DSC', statekey: 'Warri'
//     },
//     {
//         key: 246, value: 'Effurun', statekey: 'Warri'
//     },
//     {
//         key: 247, value: 'Edjeba', statekey: 'Warri' 
//     },
//     {
//         key: 248, value: 'Ekpan', statekey: 'Warri'
//     },
//     {
//         key: 249, value: 'Eneren', statekey: 'Warri'
//     },
//     {
//         key: 250, value: 'Garage', statekey: 'Warri' 
//     },
//     {
//         key: 251, value: 'GRA', statekey: 'Warri'
//     },
//     {
//         key: 252, value: 'Jakpa', statekey: 'Warri'
//     },
//     {
//         key: 253, value: 'Osubi', statekey: 'Warri' 
//     },
//     {
//         key: 254, value: 'PTI', statekey: 'Warri'
//     },
//     {
//         key: 255, value: 'Ukpoloposo', statekey: 'Warri'
//     },
  

// ]

 export const openList = [
        { key: '1', value: '24/7' },
        { key: '2', value: '8am-8pm' },
        { key: '3', value: '5pm-5am' },
        { key: '4', value: '9am-9pm' },
];
